export const progressFragment = `
  fragment progressFragment on ProgressModuleRecord {
    cards {
      ...progressCardFragment
    }
    headingProps {
      textStyle
    }
    moduleFormat{
      ...moduleFormatFragment
    }
    text {
      value
    }
    title
  }

  fragment progressCardFragment on ProgressCardRecord {
    content {
      value
    }
    progressLabel
    tabTitle
    title
  }
`;
